import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { faBell } from '@fortawesome/free-solid-svg-icons';
import Translate from '../common/Translate';

const Alerts = ({ alerts }) => {
  const listAlerts = [];
  Object.entries(alerts).forEach(([key, value]) => {
    listAlerts.push(
      <li key={key}>
        <Translate code={key} />
        {typeof value === 'string' && value !== '' && (
          <span>
            {' '}
            : <Translate code={value} />
          </span>
        )}
      </li>,
    );
  });

  return (
    <>
      {listAlerts.length > 0 && (
        <div className="report-alert">
          <div className="icon">
            <FontAwesomeIcon icon={faBell} size="2x" />
          </div>
          <div className="details">
            {listAlerts.length}
            <Translate code="alerts" />
            <ul className="mt-2">{listAlerts}</ul>
          </div>
        </div>
      )}
    </>
  );
};

export default Alerts;

Alerts.propTypes = {
  alerts: PropTypes.shape().isRequired,
};
